<template>
  <div class="EngineerList">
    <el-container>
      <!--左边  -->
      <el-aside width="34%" height="100%">
        <el-container>
          <el-header>
            <el-form ref="form" :model="form" label-width="60px" :inline="true">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="子目名称" prop="subCategoryName">
                    <el-input
                      v-model="form.subCategoryName"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="子目号" prop="subCategoryNo">
                    <el-input
                      v-model="form.subCategoryNo"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <!-- <el-col :span="12">
                  <el-form-item label="子目编码" prop="num111">
                    <el-input
                      v-model="form.num111"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col> -->

                <el-col :span="24">
                  <div class="handlePanel">
                    <el-button type="primary" @click="selectClick()"
                      >查询</el-button
                    >
                    <el-button type="info" @click="resetClick()"
                      >重置</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-header>
          <el-main>
            <el-table
              ref="multipleTable"
              :data="alltableData"
              border
              size="mini"
              style="width: 100%"
              @selection-change="handlesubSelectionChange"
              :row-class-name="setRowClassName"
            >
              <el-table-column type="selection" width="46"></el-table-column>
              <el-table-column
                type="index"
                width="46"
                label="序号"
              ></el-table-column>
              <el-table-column
                v-for="(item, index) in tableColumnDatas"
                :key="index"
                :prop="item.class"
                :label="item.labelName"
                :sortable="item.sortEnable"
                show-overflow-tooltip
              ></el-table-column>
            </el-table>
            <el-footer>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="form.pageIndex"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="form.pageSize"
                layout="total, prev, pager, next, sizes"
                :total="totalCount"
              ></el-pagination>
            </el-footer>
          </el-main>
        </el-container>
      </el-aside>
      <!--右边  -->
      <el-main width="76%" height="100%">
        <el-container>
          <el-aside
            width="6%"
            height="100%"
            style="margin-top: 260px"
            class="middlebtn"
          >
            <el-button
              @click="confirmsubEngineer"
              icon="el-icon-d-arrow-right"
            ></el-button>
            <el-button
              icon="el-icon-d-arrow-left"
              @click="DelectSubEngineer()"
            ></el-button>
          </el-aside>
          <el-main style="margin-top: 32px; padding-right: 0">
            <div class="operatePanel">
              <!-- <el-button type="primary" icon="el-icon-plus" @click="choiceSubEngineer()">选择子目</el-button> -->
              <!-- <el-button type="primary" icon="el-icon-plus" @click="saveSubEngineer()">保存</el-button> -->
              <!-- <el-button type="primary" icon="el-icon-delete" @click="DelectSubEngineer()">删除</el-button> -->
              <el-button title="下载模板" type="primary" @click="downTemplate()"
                >下载模板</el-button
              >
              <el-button
                title="导入合同"
                type="primary"
                @click="importSubEngineer()"
                >导入</el-button
              >
            </div>
            <el-table
              ref="selectTables"
              :data="showtableData"
              stripe
              border
              size="mini"
              style="width: 100%; margin-top: 26px"
              :default-sort="{ prop: 'subCategoryNo', order: 'ascending' }"
              @selection-change="handleSelectionChange"
              @row-click="rowClicked"
              :row-class-name="setRowClassName"
              :show-summary="showSum"
              :summary-method="getSummaries"
            >
              <el-table-column type="selection" width="46"></el-table-column>
              <el-table-column
                type="index"
                width="46"
                label="序号"
              ></el-table-column>
              <el-table-column
                v-for="(item, index) in subtableColumnDatas"
                :key="index"
                :prop="item.class"
                :label="item.labelName"
                :sortable="item.sortEnable"
                show-overflow-tooltip
                align="center"
                header-align="center"
              >
                <template slot-scope="scope">
                  <div v-if="scope.column.property == 'unitPrice'">
                    <el-input
                      v-if="scope.row.isEdit"
                      v-model="scope.row[scope.column.property]"
                    ></el-input>
                    <div v-if="!scope.row.isEdit">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </div>
                  <div v-else-if="scope.column.property == 'unit'">
                    <el-input
                      v-if="scope.row.isEdit"
                      v-model="scope.row[scope.column.property]"
                    ></el-input>
                    <div v-if="!scope.row.isEdit">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </div>
                  <div v-else-if="scope.column.property == 'quantity'">
                    <el-input
                      v-if="scope.row.isEdit"
                      v-model="scope.row[scope.column.property]"
                    ></el-input>
                    <div v-if="!scope.row.isEdit">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </div>
                  <div v-else-if="scope.column.property == 'comments'">
                    <el-input
                      v-if="scope.row.isEdit"
                      v-model="scope.row[scope.column.property]"
                    ></el-input>
                    <div v-if="!scope.row.isEdit">
                      {{ scope.row[scope.column.property] }}
                    </div>
                  </div>
                  <div v-else-if="scope.column.property == 'totalPrice'">
                    <div>
                      {{ (scope.row[scope.column.property] + "") | numFilter }}
                    </div>
                  </div>
                  <span v-else>{{ scope.row[scope.column.property] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    v-if="scope.row.isEdit"
                    @click="saveChange(scope.row)"
                    >保存</el-button
                  >
                  <el-button
                    type="text"
                    v-else
                    @click="editSingleTable(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-footer>
              <el-pagination
                @size-change="handleSubSizeChange"
                @current-change="handleSubCurrentChange"
                :current-page="SubpageIndex"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="SubpageSize"
                layout="total, prev, pager, next, sizes, jumper"
                :total="SubtotalCount"
              ></el-pagination>
            </el-footer>
          </el-main>
        </el-container>
      </el-main>
    </el-container>

    <!-- 导入工程量清单子目 -->
    <upload-dialog
      :isShow="showUploadDialog"
      @close="closeDialogAction"
      :isImportContract="isImportengineerDialog"
      :type="type"
      @saveImportItems="saveImportItems"
    />
  </div>
</template>

<script>
import UploadDialog from "@/page/basicData/commonCell/UploadDialog"; //导入工程量清单子目组件
import {
  getProjectDetailsList, //获取全部子目列表
  getallSubEngineerListService, //获取工程量子目table数据
  deleteoneSubEngineerSevice, //删除选中的一条子目
  exportExcelService2, //导出
  getTemplate, //下载导入模板
} from "@/services/allContractServices";
import { accMul, numFilter } from "@/utils/filters";
// import {numFilter} from "../../../utils/filters";
export default {
  name: "EngineerList",
  components: {
    UploadDialog,
  },
  props: {
    engineerItems: {
      type: Array,
    },
  },
  data() {
    return {
      type: "contract",
      subEngineerdialogVisible: false, //选择子目对话框可见性
      selectItems: [], //记录选中的要删除的子目
      selectsubItems: [], //记录选中的子目
      showUploadDialog: false, //导入对话框展示与否
      isImportengineerDialog: true, //true为导入工程量清单可见性
      showSum: true, //是否展示合计行
      subtableColumnDatas: [
        // { class: "subCategoryNo", labelName: "序号", sortEnable: false },
        { class: "subCategoryNo", labelName: "子目号", sortEnable: true },
        { class: "subCategoryName", labelName: "子目名称", sortEnable: false },
        { class: "unit", labelName: "计量单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        { class: "unitPrice", labelName: "单价", sortEnable: false },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        { class: "comments", labelName: "备注", sortEnable: false },
      ],
      tableColumnDatas: [
        // { class: "serialNumber", labelName: "序号", sortEnable: false },
        { class: "subCategoryNo", labelName: "子目号", sortEnable: false },
        { class: "subCategoryName", labelName: "子目名称", sortEnable: false },
        { class: "unit", labelName: "计量单位", sortEnable: false },
        // { class: "quantity", labelName: "数量", sortEnable: false },
        // { class: "unitPrice", lab  elName: "单价", sortEnable: false },
        // { class: "totalPrice", labelName: "金额", sortEnable: false },
      ],
      form: {
        subCategoryNo: "", //子目号
        subCategoryName: "", //子目名称
        pageIndex: 1,
        pageSize: 10,
      },
      SubpageSize: 10,
      SubpageIndex: 1,
      SubtotalCount: 0,
      showAdvanceFilter: false,
      pageIndex: 1,
      pageSize: 50,
      totalCount: 0,
      tableData: [], //已选择的子目名称
      showtableData: [], //展示得已选择的子目名称
      alltableData: [], //所有子目列表
      showExportDialog: false,
    };
  },
  mounted() {
    this.form.pageIndex = 1;
    this.SubpageIndex = 1;
    // this.initList(); //获取列表  gaa 20200826
    if (this.tableData && this.tableData.length > 0) {
      this.initSubList();
    }
  },

  watch: {
    engineerItems(newVal) {
      if (newVal.length >= 0) {
        this.tableData = newVal;
        this.initSubList();
      }
    },
  },
  methods: {
    /* 查询按钮回调 */
    selectClick() {
      this.form.pageIndex = 1;
      this.initList();
    },
    /* 重置按钮回调 */
    resetClick() {
      this.$refs.form.resetFields();
      this.initList();
    },
    initList() {
      getProjectDetailsList(this.form, true)
        .then((res) => {
          if (res.code == 10000000) {
            this.alltableData = res.data;
            this.totalCount = res.total;
            try {
              this.tableHeight = this.$refs.main.$el.offsetHeight - 10;
            } catch (error) {
              console.log("-- tableHeight error\n", error);
            }
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          // this.$message.error(error.msg);
        });
    }, //
    /* 分页改变事件 */
    handleCurrentChange(page) {
      this.form.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.form.pageSize = rows;
      this.form.pageIndex = 1;
      //  this.selectsubItems.length=0;
      this.initList();
    },
    /* 分页改变事件 */
    handleSubCurrentChange(page) {
      this.SubpageIndex = page;
      this.initSubList();
    },
    /* 分页显示数量改变事件 */
    handleSubSizeChange(rows) {
      this.SubpageSize = rows;
      this.SubpageIndex = 1;
      //  this.selectsubItems.length=0;
      this.initSubList();
    },
    initSubList() {
      this.SubtotalCount = this.tableData.length;
      this.showtableData = this.tableData.slice(
        this.SubpageSize * (this.SubpageIndex - 1),
        this.SubpageSize * this.SubpageIndex
      );
    },
    //审批关闭
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //选择要删除的工程量清单子目
    handleSelectionChange(val) {
      this.selectItems = val;
      console.log(val);
    },
    //已选中的要添加的工程量清单子目
    handlesubSelectionChange(val) {
      this.selectsubItems = val;
      //  for (let i = 0; i < val.length; i++) {
      //    if(!this.selectsubItems.includes(val[i]))
      //    {
      //       this.selectsubItems.push(val[i]);
      //    }
      //  }
    },
    setRowClassName({ row, rowIndex }) {
      if (row.isOverTime != 0) {
        return "overTimeMark";
      }
    }, //
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.selectTables.toggleRowSelection(row);
    },

    //导入工程量清单子目
    importSubEngineer() {
      this.isImportengineerDialog = true;
      this.showUploadDialog = true;
    },

    //删除选中的子目
    DelectSubEngineer() {
      if (this.selectItems.length < 1) {
        this.$alert("请至少选择一条数据", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      this.$confirm("确认移除该条子目吗?", "提示", {
        confirmButtonText: "确认",
      })
        .then(() => {
          for (let i = 0; i < this.selectItems.length; i++) {
            for (let j = 0; j < this.tableData.length; j++) {
              if (this.tableData[j].id == this.selectItems[i].id) {
                this.tableData.splice(j, 1);
                // this.initSubList()
                this.$emit("saveChoiceItems", this.tableData);
              }
            }
          }
        })
        .catch(() => {
          //dosomething
        });
    },

    //保存选中的子目
    saveSubEngineer() {
      this.$emit("saveChoiceItems", this.tableData);
    },

    //确认对话框选择的子目数据
    confirmsubEngineer() {
      if (this.selectsubItems.length < 1) {
        this.$alert("请选择新增条目", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {};
      this.$confirm("确认添加选中子目吗？", "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        let addFlag = true;
        if (this.tableData.length > 0) {
          for (let i = 0; i < this.selectsubItems.length; i++) {
            for (let j = 0; j < this.tableData.length; j++) {
              if (this.tableData[j].id == this.selectsubItems[i].id) {
                addFlag = false;
                break;
              }
            }
            if (addFlag) {
              if (this.selectsubItems[i].unit) {
                this.selectsubItems[i].quantity = 0;
                this.selectsubItems[i].unitPrice = 0;
                this.selectsubItems[i].totalPrice = 0;
              } else {
                this.selectsubItems[i].quantity = "";
                this.selectsubItems[i].unitPrice = "";
                this.selectsubItems[i].totalPrice = "";
              }

              this.selectsubItems[i].comments = "";
              this.selectsubItems[i].isEdit = false;
              let item = { ...this.selectsubItems[i] };
              this.tableData.push(item);
            }
            addFlag = true;
          }
        } else {
          for (let i = 0; i < this.selectsubItems.length; i++) {
            if (this.selectsubItems[i].unit) {
              this.selectsubItems[i].quantity = 0;
              this.selectsubItems[i].unitPrice = 0;
              this.selectsubItems[i].totalPrice = 0;
            } else {
              this.selectsubItems[i].quantity = "";
              this.selectsubItems[i].unitPrice = "";
              this.selectsubItems[i].totalPrice = "";
            }
            this.selectsubItems[i].comments = "";
            this.selectsubItems[i].isEdit = false;
            let item = { ...this.selectsubItems[i] };
            this.tableData.push(item);
          }
          console.log(this.tableData[0]);
        }
        this.subEngineerdialogVisible = false;
        this.$emit("saveChoiceItems", this.tableData);
        this.$refs.multipleTable.clearSelection();
        this.selectsubItems.length = 0;
      });
    },
    //关闭导入对话框
    closeDialogAction() {
      this.showUploadDialog = false;
    },
    closeDialog() {
      this.showExportDialog = false;
    },
    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },

    //下载工程里清单合同模板
    downTemplate() {
      let category = "PROJECT_DETAILS"; //工程量清单模板
      getTemplate(category).then(
        (res) => {
          console.log(res);
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              // this.$alert("成功", "提示", {
              //   confirmButtonText: "确定"
              // });
            });
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          // this.$message.error(err.msg);
        }
      );
    },

    //保存导入的工程量清单
    saveImportItems(selectItems) {
      if (selectItems.length > 0) {
        this.tableData=[]//this.tableData.filter(item=>!item.isImport)
        for (let i = 0; i < selectItems.length; i++) {
          let data = { ...selectItems[i] };
          // let index = this.tableData.findIndex(
          //   (item) =>
          //     item.subCategoryNo == data.subCategoryNo &&
          //     item.subCategoryName == data.subCategoryName
          // );
          if (data.quantity && data.unitPrice) {
            data.totalPrice = accMul(data.quantity, data.unitPrice);
          } else {
            data.totalPrice = "";
          }
          data.isImport = true;
          data.isEdit = false;
          // if (index != -1) 
          // this.tableData.splice(index, 1);
          this.tableData.push(data);
        }
      }
      this.showUploadDialog = false;
      this.$emit("saveChoiceItems", this.tableData);
    },
    /**
     * 当前表格的数量、备注修改
     * @param
     * row   Object  当前选中的行数据
     **/
    saveChange(row) {
      if (row.quantity !== "" && row.unitPrice !== "") {
        row.totalPrice = accMul(row.quantity, row.unitPrice);
      } else {
        row.totalPrice = "";
      }
      console.log(row.totalPrice);
      row.isEdit = false;
      this.$emit("saveChoiceItems", this.tableData);
    },
    editSingleTable(row) {
      row.isEdit = true;
      this.$nextTick().then(() => {
        row.isEdit = true;
      });
    },

    //设置小计
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 4) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "quantity" || column.property == "totalPrice")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // if (column.property == "quantity") {
          //   sums[index] += "";
          // } else {
          sums[index] = numFilter(sums[index]);
          // }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
/deep/.el-button--primary {
  min-width: 60px;
}
/deep/.el-button--info {
  min-width: 60px;
}
.EngineerList {
  min-width: 1226px;
  .operatePanel {
    text-align: right;
  }
  .handlePanel .el-button {
    padding: 8px 5px;
    margin-bottom: 10px;
    margin-left: 6px;
    margin-top: 0px;
  }
  .middlebtn .el-button {
    padding: 10px 10px;
    margin-bottom: 10px;
    margin-left: 6px;
    margin-top: 10px;
  }
}
/deep/.el-container .el-main {
  height: 100%;
}
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
    .el-form-item {
      margin-top: 6px;
    }
  }
  /deep/.el-main {
    padding-top: 0px;
    padding: 10px;
  }

  /deep/.el-footer {
    padding: 0 0;
  }
  .el-footer .el-pagination {
    padding-top: 6px;
    padding-bottom: 6px;
  }
}

.hide {
  display: none;
}
</style>
